import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  socket: null,
  connected: false,
  connecting: false,
  error: null,
  userDisconnected: false, // Track if user manually disconnected
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setSocket: (state, action) => {
      state.socket = action.payload;
    },
    setConnected: (state, action) => {
      state.connected = action.payload;
    },
    setConnecting: (state, action) => {
      state.connecting = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },

    setUserDisconnected: (state, action) => {
      state.userDisconnected = action.payload;
    },
  },
});

export const {
  setSocket,
  setConnected,
  setConnecting,
  setError,
  clearError,
  setUserDisconnected,
} = websocketSlice.actions;

export default websocketSlice.reducer;
